import axios from 'axios'
import qs from 'qs'
import { message } from 'ant-design-vue'
import router from '@/router'
import Cookies from 'js-cookie'

// 创建axios实例
const service = axios.create({
  baseURL: '', // api的base_url
  withCredentials: true, // 携带cookie
  timeout: 60000, // request timeout
})

// 拦截request,设置全局请求为ajax请求
service.interceptors.request.use(
  (config) => {
    // config.headers['X-Requested-With'] = 'XMLHttpRequest'
    if (config.data && config.data.upload) {
      config.headers['Content-Type'] = 'multipart/form-data'
      const f = new FormData()
      for (let key in config.data) {
        if (key !== 'upload') {
          f.append(key, config.data[key])
        }
      }
      config.data = f
    } else if (config.headers['Content-Type'] === undefined) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
      if (config.method === 'post') {
        config.data = qs.stringify(config.data)
      }
    }
    return config
  },
  (error) => {
    // Do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// 拦截响应response，并做一些错误处理
service.interceptors.response.use(
  (response) => {
    // HTTP:200 接收成功返回数据
    if (response.data.code === 40405 || response.data.code === 403) {
      Cookies.remove('ukey', { path: '/', domain: '.ehafo.com' })
      Cookies.remove('userid', { path: '/', domain: '.ehafo.com' })
      const redirectPath = window.location.pathname + window.location.search
      localStorage.setItem('loginRedirect', redirectPath)
      router.replace({
        path: '/login',
      })
      return Promise.reject(response.data)
    }
    return Promise.resolve(response.data)
  },
  (error) => {
    if (error.response) {
      message.error('接口请求失败，请稍后再试')
    } else if (/^timeout/.test(error.message)) {
      message.error('请求超时')
    } else {
      message.error('系统异常，请稍后再试')
    }
    return Promise.reject(error)
  }
)

export default service
